import 'babel-polyfill'
import 'es6-map/implement'
import React from 'react'
import ReactDOM from 'react-dom'
import '../explore'; // syndication includes explore
import './styles/custom_properties.scss';
import '../Components/Blanco';
import '../Components/Graphik';
import '../Components/Doyle';
import './Components/ArticleContent';
import './Components/ArticleFooter';
import './Components/ArticleHeader';
import './Components/ArticlePage';
import './Components/Attribution';
import './Components/Ad';
import './Components/JoinUs';
import './Components/PersistentActions';
import PublisherModule from './Components/PublisherLinks';
import MoreFromPocketModule from './Components/MoreFromPocket';
import PublisherCta from './Components/PublisherCta';
import PersistentActions from './Components/PersistentActions';
import './Components/MoreFromPocket';
import CookieTrackingBootstrapper from './cookieTracking';
import trackDepth from './depthTracking';

const ARTICLE_CONTENT_SELECTOR = '#article-content';
const DEPTHS_TO_TRACK = [25, 50, 75, 100];

/**
 * Remove all inline styles from
 *
 * TODO: Replace this with server side logic.
 */
const articleRemoveImageStyles = () => {
  document.querySelectorAll('.article-content img[style]').forEach(el => {
    el.setAttribute('style', '');
  });
}

document.addEventListener("DOMContentLoaded", function (event) {
  articleRemoveImageStyles();
  CookieTrackingBootstrapper();
  trackDepth(ARTICLE_CONTENT_SELECTOR, DEPTHS_TO_TRACK);
});


const apps = [
  {
    id: 'syndicated-article-publisher-recirc-container',
    element: PublisherModule,
  },
  {
    id: 'more-from-pocket-container',
    element: MoreFromPocketModule,
  },
  {
    id: 'publisher-cta-container',
    element: PublisherCta
  },
  {
    id: 'persistent-actions-container--left',
    element: PersistentActions
  },
  {
    id: 'persistent-actions-container--content-top',
    element: PersistentActions,
    props: {
      isMobileOnly: true,
      isTopOfPage: true
    }
  },
  {
    id: 'persistent-actions-container--content-bottom',
    element: PersistentActions,
    props: {
      isMobileOnly: true,
    }
  },
];

document.addEventListener('DOMContentLoaded', () => {
  apps.forEach(({id, element: Element, props}) => {
    const el = document.getElementById(id);

    if (el) {
      ReactDOM.render(<Element {...props}/>, el)
    }
  })
});
